import { computed, ref } from 'vue';
import { t } from '@/utils/i18n-helper';
import monederoService from '@/services/perfil/monedero';
import { normalizeAmount } from './monedero.utils';

export function useMonedero() {
    const movimientos = ref([]);
    const loading = ref(false);
    const error = ref(null);
    let initialized = false;

    const total = computed(() => movimientos.value.reduce((sum, item) => sum + normalizeAmount(item?.importe), 0));

    const fetchMonedero = async({ force = false } = {}) => {
        if (loading.value) return;
        if (initialized && !force) return;

        loading.value = true;
        error.value = null;

        try {
            movimientos.value = await monederoService.getMonedero();
            initialized = true;
        } catch (err) {
            movimientos.value = [];
            error.value = err?.message ?? t('perfil.monedero_error_cargar', {}, 'No se pudo cargar el monedero');

            if (process.env.NODE_ENV !== 'production') {
                console.error('[useMonedero] Error al cargar el monedero:', err);
            }
        } finally {
            loading.value = false;
        }
    };

    return {
        movimientos,
        total,
        loading,
        error,
        fetchMonedero,
    };
}
